export default "__VITE_ASSET__C$hwZpIE__"